import React from "react";
import { UserEditPage, USER_TYPES } from "../../modules/user-management";

const TenantUserEdit = () => (
  <UserEditPage userType={USER_TYPES.TENANT} />
);

export default TenantUserEdit;
